import styled from 'styled-components';

import {
  Image,
  Container as ContainerSemanticUI,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div``;

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const IconTitle = styled(Image)`
  &&&{
    width: 25px;
    height: 25px;
  }
`;

export const Title = styled(TextLayoutComponent)`
  margin-left: auto;

  ${(props) => props.theme.color[props.color] && `
    margin-left: 10px;
    color: ${props.theme.color[props.color]};
  `}

  font-weight: 500;
`;

export const QuestionIndex = styled(TextLayoutComponent)`
  font-weight: 900;
  padding: 10px;
`;

export const Content = styled(ContainerSemanticUI)`
  display: flex;
  align-items: center;
  margin: 10px;
`;

export const FieldSmall = styled.div`
  width: 75px;
  margin: 0 5px;
`;

export const AlignedSpan = styled.span`
  display: flex;
  align-items: center;
`;

export const SubTitle = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.multipleDropdown};
  font-weight: 500;
  margin: 20px 0 0 10px;
`;
